export const makeForgotPasswordDTO = () => ({});
